import React, { useState, useRef } from "react";
import { Grid, TextField } from "@mui/material";
import Box from "@mui/material/Box";
import { IFlashInfoState } from "./interface";

interface IAddProps {
  flashInfoState: IFlashInfoState,
  setFlashInfoState: (x: IFlashInfoState) => void
}


const Edit = (props: IAddProps) => {

  //props
  const {
    flashInfoState, setFlashInfoState
  } = props


  //fonctions
  const handleInputChange = (e: any) => {
    const { value, name } = e.target
    setFlashInfoState({ ...flashInfoState, [name]: value })
  }


  return (
    <Box sx={{ flexGrow: 1, width: "100%" }}>
      <Grid
        container
        spacing={2}
        direction="row"
        justifyContent="flex-start"
        alignItems="center"
      >
        <Grid item md={6} xs={12} sm={6}>
          <TextField
            fullWidth
            multiline
            minRows={5}
            size="small"
            name="titreInfo"
            label="Information"
            value={flashInfoState.titreInfo}
            onChange={handleInputChange}
          />
        </Grid>
      </Grid>
    </Box>
  );
};
export default Edit;
